export const services = [
  {
    id: "unarmed-security",
    title: "Unarmed Security",
    description: "Professional security personnel for comprehensive protection of your assets, property, and people. Fully licensed and trained for any environment.",
    icon: "ri-shield-check-line",
  },
  {
    id: "executive-protection",
    title: "Executive Protection",
    description: "Discreet VIP protection services for high-profile individuals, corporate executives, and dignitaries. Available locally and for travel.",
    icon: "ri-user-star-line",
  },
  {
    id: "event-security",
    title: "Event Security & Crowd Management",
    description: "Crowd control and security management for events of all sizes — from corporate gatherings to large public festivals and concerts.",
    icon: "ri-group-line",
  },
  {
    id: "vehicle-patrol",
    title: "Vehicle Patrol Services",
    description: "Regular mobile security patrols for residential communities, commercial properties, and industrial facilities to deter and detect threats.",
    icon: "ri-car-line",
  },
  {
    id: "fire-watch",
    title: "Fire Watch Services",
    description: "Certified fire watch personnel ensuring safety compliance during construction, maintenance, and system outages.",
    icon: "ri-fire-line",
  },
  {
    id: "construction-security",
    title: "Construction Site Security",
    description: "Specialized security solutions for active construction sites and industrial facilities, protecting equipment and materials.",
    icon: "ri-building-line",
  },
  {
    id: "alarm-response",
    title: "Alarm Response & Property Checks",
    description: "Rapid response to alarm activations to verify threats, secure property, and coordinate with law enforcement when needed.",
    icon: "ri-alarm-warning-line",
  },
  {
    id: "retail-loss",
    title: "Retail & Loss Prevention",
    description: "Protect your inventory and bottom line with expert loss prevention strategies and undercover security personnel.",
    icon: "ri-shopping-bag-line",
  },
  {
    id: "concierge-security",
    title: "Concierge & Front Desk Security",
    description: "A professional and welcoming security presence for your building's front lobby, managing visitor access with discretion.",
    icon: "ri-customer-service-line",
  },
];